const AuthRoutes = require('routes/auth/config');
const PersistenceConfig = require('./persistence-config');

const { keys: STORAGE_KEYS } = PersistenceConfig;

const AUTH_FLOW_STATUSES = Object.freeze({
    passwordRequired: 'password_required',
    ssoRequired: 'sso_required',
    mfaRequired: 'mfa_required',
    mfaSetupRequired: 'mfa_setup_required',
    authenticated: 'authenticated'
});

module.exports = {
    logTag: '[auth-management]',
    persistence: PersistenceConfig,
    debugStorageKey: STORAGE_KEYS.debug,
    flowStorageKey: STORAGE_KEYS.debugFlows,
    errorStorageKey: STORAGE_KEYS.debugErrors,
    apiDebugStorageKey: STORAGE_KEYS.debugApi,
    maxStoredFlows: 50,
    maxStoredErrors: 50,
    maxStoredApiExchanges: 20,
    policy: {
        nearpeerInternalEmailDomains: [
            'nearpeer.net',
            'nearpeer.com'
        ]
    },
    authFlow: {
        methods: {
            password: 'password',
            sso: 'sso',
            mfa: 'mfa'
        },
        statuses: AUTH_FLOW_STATUSES,
        pendingMfaStatuses: Object.freeze([
            AUTH_FLOW_STATUSES.mfaRequired,
            AUTH_FLOW_STATUSES.mfaSetupRequired
        ]),
        reasons: {
            mfaChallenge: 'mfa_challenge',
            mfaOverride: 'mfa_override',
            apiSso: 'api_sso',
            apiPassword: 'api_password'
        },
        sources: {
            unknown: 'unknown',
            schoolCheck: 'school_check',
            mfaChallenge: 'mfa_challenge',
            signupPasswordCheck: 'signup_password_check',
            signupRouteProgress: 'signup_route_progress',
            signupCompletionMfa: 'signup_completion_mfa',
            profilePhoneUpdate: 'profile_phone_update',
            incompleteSignupLogin: 'incomplete_signup_login',
            loginRouteContext: 'login_route_context',
            signupRouteContext: 'signup_route_context',
            passwordLoginSsoRequired: 'password_login_sso_required',
            loginSuccess: 'login_success'
        },
        routes: AuthRoutes,
        mfaMethods: {
            sms: 'sms'
        },
        mfaCompletionClassifications: {
            authenticated: 'authenticated',
            signupCompletion: 'signup-completion'
        }
    },
    token: {
        storageKey: STORAGE_KEYS.token
    },
    termsAgreement: {
        storageKey: STORAGE_KEYS.termsAgreement
    },
    loginContext: {
        storageKey: STORAGE_KEYS.loginContext,
        persistedFields: [
            'lastLoginEmail'
        ],
        runtimeResetFields: {
            schoolId: null,
            roleId: null,
            sso: null,
            mfaToken: null,
            mfaMethod: null,
            mfaPurpose: null,
            mfaNeedsPhone: null,
            mfaPhone: null,
            mfaPhoneCountry: null,
            mfaCooldownCode: null,
            mfaCooldownUntil: null,
            maskedDestination: null,
            canChangePhone: null,
            verificationToken: null,
            authMethod: null,
            authStatus: null,
            authFlowSource: null,
            hasPassword: null,
            forceSSOLoginPromptEmail: null,
            skipSSOLoginPromptEmail: null,
            redirect: null,
            redirectTarget: null,
            policy: null
        }
    },
    signupContext: {
        storageKey: STORAGE_KEYS.signupContext,
        persistedFields: [
            'verificationToken',
            'permissions',
            'roleId',
            'email',
            'schoolId',
            'hasPassword',
            'hasSSOToken',
            'agreeToTerms'
        ],
        resetFields: {
            verificationToken: null,
            roleId: null,
            fetchedProgress: false,
            sso: null,
            mfaToken: null,
            mfaMethod: null,
            mfaPurpose: null,
            mfaNeedsPhone: null,
            mfaPhone: null,
            mfaPhoneCountry: null,
            mfaCooldownCode: null,
            mfaCooldownUntil: null,
            maskedDestination: null,
            canChangePhone: null,
            pendingPreferences: null,
            isVerified: null,
            isEmailVerified: null,
            hasCompletedProfile: null,
            hasPassword: null,
            hasSSOToken: null,
            agreeToTerms: null,
            authMethod: null,
            authStatus: null,
            authFlowSource: null,
            forceSSOLoginPromptEmail: null,
            skipSSOLoginPromptEmail: null,
            redirect: null,
            redirectTarget: null
        }
    },
    mfaSession: {
        loginStorageKey: STORAGE_KEYS.loginMfaContext,
        signupStorageKey: STORAGE_KEYS.signupMfaContext,
        fields: [
            'email',
            'schoolId',
            'roleId',
            'verificationToken',
            'authMethod',
            'authStatus',
            'authFlowSource',
            'mfaToken',
            'mfaMethod',
            'mfaPurpose',
            'mfaNeedsPhone',
            'mfaPhone',
            'mfaPhoneCountry',
            'mfaCooldownCode',
            'mfaCooldownUntil',
            'maskedDestination',
            'canChangePhone',
            'pendingPreferences'
        ]
    },
    stages: {
        identify: {
            slice: 'identify',
            fields: ['email', 'schoolId']
        },
        authenticate: {
            slice: 'authenticate',
            fields: [
                'hasPassword',
                'hasSSOToken',
                'password',
                'verificationToken'
            ]
        },
        profile: {
            slice: 'profile'
        }
    }
};
